import { useMappingDetailsStore } from '../stores/mappingDetailsStore';

export const useMappingDetails = () => {
  const mappingDetails = useMappingDetailsStore(
    (state) => state.mappingDetails
  );
  const setMappingDetails = useMappingDetailsStore(
    (state) => state.setMappingDetails
  );
  const clearMappingDetails = useMappingDetailsStore(
    (state) => state.clearMappingDetails
  );
  const getMappingDetails = useMappingDetailsStore(
    (state) => state.getMappingDetails
  );
  const isMappingDetailsLoaded = useMappingDetailsStore((state) =>
    state.isMappingDetailsLoaded()
  );

  return {
    mappingDetails,
    isLoaded: isMappingDetailsLoaded,
    setMappingDetails,
    clearMappingDetails,
    getMappingDetails,
  };
};
